import React, { useEffect, useState } from "react";
import { getI18n, useTranslation } from "react-i18next";
import i18nn from "i18next";
import aeLogo from "../../assets/images/ae-logo.svg";
import { setEncryptSessionStorage } from "../../utils/EncryptStorage";
import hamburger from "../../assets/images/hamburger-icon.svg";
import LogoutIcon from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { FormControl, Collapse, Typography, Button } from "@mui/material";
import { useAuth } from "../../providers/Auth";
import { useNavigate } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import {
  HeaderButton,
  TimeoutButton,
  MainContainerMenu,
  MainLeftNav,
  SideRightNavItem,
  MainLeftNavItemHref,
  MainLeftNavItemLi,
  MainLeftNavItemUL,
  MainRightNav,
  MainRightNavItem,
  SideNavContainer,
  SideRightNavItemUL,
  SideRightNavItemLi,
  BoldLine,
  SideNavFooterContainer,
  PopoverDiv,
  MenuHamburgerButton,
  LogoWrapper,
  GreetingDiv,
  MainContainerDiv,
  PopOverPaper,
  DrawerPaper,
  MainWrapper,
  SideNavFooterContent,
  FooterLinks,
  SideDrawer,
  LanguageContainer
} from "../Header/Header.style";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Header() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuSignOut = e => {
    e.preventDefault();

    auth.signOut();
    toggleDrawer(false);
    handleClose();
    navigate("/login", {
      state: {
        showAlert: true,
        severity: "success",
        message: "all.alert.logout"
      }
    });
  };
  const openMenu = Boolean(anchorEl);
  const id = openMenu ? "simple-popover" : undefined;
  const [openTimeout, setOpenTimeout] = React.useState(false);
  const [sideNav, setSideNav] = React.useState(false);
  const [userInitial, setUserInitial] = React.useState("");
  const toggleDrawer = open => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setSideNav(open);
  };

  //Get User FirstName and LastName

  const userFullName = auth?.user?.userFullName;

  const { t } = useTranslation();
  const initial = (t("all.header.button.btn-initial-profile-logged-in") +
    userFullName +
    t("all.header.button.btn-initial-profile-click-profile")) as
    | string
    | undefined;

  const { i18n } = useTranslation();
  //For Languge
  const [langValue, setLangValue] = useState(getI18n().resolvedLanguage);

  const onLangSwitch = e => {
    setEncryptSessionStorage("language", e.target.checked ? "fr" : "en");
    setLangValue(e.target.checked ? "fr" : "en");
    i18nn.changeLanguage(e.target.checked ? "fr" : "en");
    window.location.reload();
  };

  useEffect(() => {
    if (auth?.user && !auth.loading) {
      let initials = auth?.user?.givenName!.charAt(0) + auth?.user?.lastName!.charAt(0)
      setUserInitial(initials.toUpperCase());
    }
  }, [auth]);

  useEffect(() => {
    i18n.changeLanguage(langValue, (err, t) => {
      if (err)
        return console.debug(
          "ERROR: header had something went wrong loading",
          err
        );
      t("key");
      document.documentElement.lang = getI18n().resolvedLanguage;
    });
  }, [i18n, langValue]);

  //Set css class based on condition
  var languageclass,
    profileClass,
    hamIconclass = "";
  if (auth?.user != null) {
    languageclass = "language-hide";
    hamIconclass = "hamIconShow";
    profileClass = "profile-show";
  } else {
    languageclass = "language-show";
    hamIconclass = "hamIconHide";
    profileClass = "profile-hide";
  }

  // DIALOG POPUP FOR TIMEOUT
  const handleTimeoutClose = () => {
    setOpenTimeout(false);
    auth.signOut();
    navigate("/login", {
      state: {
        showAlert: true,
        severity: "success",
        message: "all.alert.logout"
      }
    });
  };

  const handleTimeoutRefresh= () => {
    setOpenTimeout(false);
    window.location.reload();
  };

  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (openTimeout && oldProgress > 99) {
          setOpenTimeout(false);
          auth.signOut();
          navigate("/login", {
            state: {
              showAlert: true,
              severity: "error",
              message: "all.alert.session-expired"
            }
          });
        }
        return Math.min(oldProgress + 1, 100);
      });
    }, 600);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line
  }, [openTimeout]);

  const timeout = Number(process.env.REACT_APP_TIMEOUT) - 1;
  useEffect(() => {
    // when the component is mounted, the alert is displayed for 3 seconds
    setTimeout(() => {
      const cu = auth.currentUser();
      if(cu !== null){
        setOpenTimeout(true);
        setProgress(1);
      }
    }, (timeout * 60 * 1000));
    // eslint-disable-next-line
  }, []);   

  return (
    <>
      <Dialog
        open={openTimeout}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleTimeoutClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{ fontSize: "2rem", fontWeight: "bold" }}>{t("all.header.timeout.title")}</DialogTitle>
        <LinearProgress variant="determinate" value={progress} />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" sx={{ fontSize: "1.5rem"}}>
            {t("all.header.timeout.description")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <TimeoutButton onClick={handleTimeoutClose}>{t("all.header.button.btn-no")}</TimeoutButton>
          <TimeoutButton onClick={handleTimeoutRefresh}>{t("all.header.button.btn-yes")}</TimeoutButton>
        </DialogActions>
      </Dialog>
      <MainWrapper>
        <MainContainerDiv>
          <MainContainerMenu>
            {/* LeftSide menu item */}
            <MainLeftNav>
              <div className="logo-wrapper">
                <img src={aeLogo} alt="AEROPLAN" />
              </div>
            </MainLeftNav>
            {/* Rightside menu item */}
            <MainRightNav>
              <MainRightNavItem>
                <Collapse in={auth?.user !== null}>
                  <div className="main-left-nav-item">
                    <MainLeftNavItemUL>
                      <MainLeftNavItemLi>
                        <MainLeftNavItemHref
                          className="main-menu"
                          href="./#/home"
                        >
                          {" "}
                          {t("all.header.link.home")}
                        </MainLeftNavItemHref>
                      </MainLeftNavItemLi>
                      <MainLeftNavItemLi>
                        <MainLeftNavItemHref
                          className="main-menu"
                          href="./#/validate"
                        >
                          {t("all.header.link.validate")}
                        </MainLeftNavItemHref>
                      </MainLeftNavItemLi>
                      {auth?.user?.authorities.find(authority => authority === "pactool_admin") &&
                        <MainLeftNavItemLi>
                          <MainLeftNavItemHref
                            className="main-menu"
                            href="./#/crediting"
                          >
                            {t("all.header.link.issue-points")}
                          </MainLeftNavItemHref>
                        </MainLeftNavItemLi>                      
                      }
                      <MainLeftNavItemLi>
                        <MainLeftNavItemHref
                          className="main-menu"
                          href="./#/transactions"
                        >
                          {t("all.header.link.view-transactions")}
                        </MainLeftNavItemHref>
                      </MainLeftNavItemLi>
                    </MainLeftNavItemUL>
                  </div>
                </Collapse>

                <div className={languageclass}>
                  <LanguageContainer panelopen="FR" paneloff="EN">
                    <label className="lang-toggle">
                      <input
                        type="checkbox"
                        checked={langValue === "fr" ? true : false}
                        onChange={onLangSwitch}
                        tabIndex={0}
                        aria-label={t("all.header.sr.language-menu")}
                      />
                      <span className="slider"></span>
                      <span className="labels" aria-hidden="true"></span>
                    </label>
                  </LanguageContainer>
                </div>
                <div className={profileClass}>
                  <Collapse in={auth?.user !== null}>
                    <GreetingDiv>
                      {userInitial === "" ? (
                        <HeaderButton>
                          <PersonOutlineIcon
                            sx={{ fontSize: "3rem" }}
                          ></PersonOutlineIcon>
                        </HeaderButton>
                      ) : (
                        <HeaderButton
                          tabIndex={0}
                          aria-label={initial}
                          sx={{
                            "&:hover": {
                              backgroundColor: "White",
                              boxShadow: "0px 2px 2px 0px rgba(0,0,0,0.75)"
                            },
                            "&:focus-visible": {
                              backgroundColor: "White",
                              boxShadow: "0px 2px 2px 0px rgba(0,0,0,0.75)"
                            }
                          }}
                          color="secondary"
                          onClick={handleClick}
                        >
                          {userInitial}
                        </HeaderButton>
                      )}
                    </GreetingDiv>
                    <PopoverDiv
                      id={id}
                      open={openMenu}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                      }}
                    >
                      <PopOverPaper>
                        <HeaderButton
                          sx={{ border: "1px solid #EBE7E6" }}
                          color="secondary"
                          aria-describedby={id}
                        >
                          {userInitial}
                        </HeaderButton>
                        <Typography
                          component={Link}
                          to="./user-profile"
                          variant="body1"
                          target="_parent"
                        >
                          {userFullName}
                        </Typography>
                      </PopOverPaper>
                      <BoldLine></BoldLine>
                      <MainLeftNavItemUL
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <MainLeftNavItemLi
                          sx={{ paddingTop: "5px", paddingBottom: "0" }}
                        >
                          <Button
                            disableRipple
                            disableFocusRipple
                            variant="text"
                            className="menu-action"
                            onClick={handleMenuSignOut}
                          >
                            <LogoutIcon
                              sx={{
                                fontSize: "2rem",
                                transform: "rotate(180deg)"
                              }}
                            ></LogoutIcon>
                            <span className="menu-text">
                              {t("all.header.link.logout")}
                            </span>
                          </Button>
                        </MainLeftNavItemLi>
                      </MainLeftNavItemUL>
                    </PopoverDiv>
                  </Collapse>
                </div>
              </MainRightNavItem>
              <div className={hamIconclass}>
                <Collapse in={auth?.user !== null}>
                  <MenuHamburgerButton onClick={toggleDrawer(true)}>
                    <img src={hamburger} alt="" width="100%" height="100%" />
                  </MenuHamburgerButton>
                </Collapse>
              </div>
            </MainRightNav>
          </MainContainerMenu>
          {/* SideHamburger menu item(mobile and desktop) */}
          <Collapse in={auth?.user !== null}>
            <SideNavContainer>
              <SideDrawer
                anchor="right"
                open={sideNav}
                onClose={toggleDrawer(false)}
              >
                <DrawerPaper>
                  <LogoWrapper>
                    <img src={aeLogo} alt="AEROPLAN" />
                  </LogoWrapper>
                  <CloseIcon
                    className="close-icon"
                    onClick={toggleDrawer(false)}
                  ></CloseIcon>
                </DrawerPaper>
                <SideRightNavItem>
                  <div className="side-profile-item">
                    <div className="side-profile">
                      <HeaderButton
                        className="user-icon"
                        sx={{ border: "1px solid #EBE7E6" }}
                        color="secondary"
                        aria-describedby={id}
                      >
                        {userInitial}
                      </HeaderButton>{" "}
                      <Typography
                        component={Link}
                        to="./view-profile"
                        variant="body1"
                        target="_parent"
                      >
                        {userFullName}
                      </Typography>
                    </div>
                    <div className="side-profile">
                      <Button
                        className="side-btn-profile"
                        variant="outlined"
                        onClick={() => (window.location.href = "./user-info")}
                      >
                        {t("user-info.block1.header.page-title")}{" "}
                      </Button>{" "}
                      <Button
                        className="side-btn-profile"
                        variant="outlined"
                        onClick={handleMenuSignOut}
                      >
                        {t("all.header.link.logout")}
                      </Button>
                    </div>
                    <li className="side-profile-line">
                      <div className="side-bold-line"></div>
                    </li>
                  </div>

                  <SideRightNavItemUL>
                    <SideRightNavItemLi>
                      <MainLeftNavItemHref
                        className="side-menu-text"
                        href="./shipments-dashboard"
                      >
                        {t("all.header.link.shipment-list")}{" "}
                      </MainLeftNavItemHref>
                      <BoldLine></BoldLine>
                    </SideRightNavItemLi>
                    <SideRightNavItemLi>
                      <MainLeftNavItemHref
                        className="side-menu-text"
                        href="./contact"
                      >
                        {" "}
                        {t("all.header.link.got-an-issue")}{" "}
                      </MainLeftNavItemHref>
                      <BoldLine></BoldLine>
                    </SideRightNavItemLi>
                  </SideRightNavItemUL>

                  <SideNavFooterContainer>
                    <SideNavFooterContent>
                      <FormControl sx={{ m: 1, width: "100%" }}>
                        <div className="side-lang">
                          <LanguageContainer panelopen="FR" paneloff="EN">
                            <label className="lang-toggle">
                              <input
                                type="checkbox"
                                checked={langValue === "fr" ? true : false}
                                onChange={onLangSwitch}
                                tabIndex={0}
                                aria-label={t("all.header.sr.language-menu")}
                              />
                              <span className="slider"></span>
                              <span
                                className="labels"
                                aria-hidden="true"
                              ></span>
                            </label>
                          </LanguageContainer>
                        </div>
                      </FormControl>
                      <BoldLine> </BoldLine>
                      <FooterLinks>
                        <Typography
                          component="a"
                          color="black.main"
                          href={`${process.env.REACT_APP_SMARTKARGO_BASE_URL}privacy-policy`}
                          target="_blank"
                        >
                          {t("all.footer.link.privacy-policy")}
                        </Typography>
                        <Typography
                          component="a"
                          color="black.main"
                          href={`${process.env.REACT_APP_SMARTKARGO_BASE_URL}terms-of-use`}
                          target="_blank"
                        >
                          {t("all.footer.link.terms-of-use")}
                        </Typography>
                        <Typography
                          component="a"
                          color="black.main"
                          href={`${process.env.REACT_APP_SMARTKARGO_BASE_URL}cookie-policy`}
                          target="_blank"
                        >
                          {t("all.footer.link.cookies-policy")}
                        </Typography>
                      </FooterLinks>
                    </SideNavFooterContent>
                  </SideNavFooterContainer>
                </SideRightNavItem>
              </SideDrawer>
            </SideNavContainer>
          </Collapse>
        </MainContainerDiv>
      </MainWrapper>
    </>
  );
}
export default Header;
